export default {
    "AF": {
        "name": "Afghanistan"
    },
    "ZA": {
        "name": "Afrique du Sud"
    },
    "AL": {
        "name": "Albanie"
    },
    "DZ": {
        "name": "Algérie"
    },
    "DE": {
        "name": "Allemagne"
    },
    "AD": {
        "name": "Andorre"
    },
    "AO": {
        "name": "Angola"
    },
    "AG": {
        "name": "Antigua-et-Barbuda"
    },
    "SA": {
        "name": "Arabie saoudite"
    },
    "AR": {
        "name": "Argentine"
    },
    "AM": {
        "name": "Arménie"
    },
    "AU": {
        "name": "Australie"
    },
    "AT": {
        "name": "Autriche"
    },
    "AZ": {
        "name": "Azerbaïdjan"
    },
    "BS": {
        "name": "Bahamas"
    },
    "BH": {
        "name": "Bahreïn"
    },
    "BD": {
        "name": "Bangladesh"
    },
    "BB": {
        "name": "Barbade"
    },
    "BY": {
        "name": "Biélorussie"
    },
    "BE": {
        "name": "Belgique"
    },
    "BZ": {
        "name": "Belize"
    },
    "BJ": {
        "name": "Bénin"
    },
    "BT": {
        "name": "Bhoutan"
    },
    "BO": {
        "name": "Bolivie"
    },
    "BA": {
        "name": "Bosnie-Herzégovine"
    },
    "BW": {
        "name": "Botswana"
    },
    "BR": {
        "name": "Brésil"
    },
    "BN": {
        "name": "Brunei"
    },
    "BG": {
        "name": "Bulgarie"
    },
    "BF": {
        "name": "Burkina Faso"
    },
    "BI": {
        "name": "Burundi"
    },
    "KH": {
        "name": "Cambodge"
    },
    "CM": {
        "name": "Cameroun"
    },
    "CA": {
        "name": "Canada"
    },
    "CV": {
        "name": "Cap-Vert"
    },
    "CF": {
        "name": "République centrafricaine"
    },
    "CL": {
        "name": "Chili"
    },
    "CN": {
        "name": "Chine"
    },
    "CY": {
        "name": "Chypre (pays)"
    },
    "CO": {
        "name": "Colombie"
    },
    "KM": {
        "name": "Comores (pays)"
    },
    "CG": {
        "name": "République du Congo"
    },
    "CD": {
        "name": "République démocratique du Congo"
    },
    "KR": {
        "name": "Corée du Sud"
    },
    "KP": {
        "name": "Corée du Nord"
    },
    "CR": {
        "name": "Costa Rica"
    },
    "CI": {
        "name": "Côte d'Ivoire"
    },
    "HR": {
        "name": "Croatie"
    },
    "CU": {
        "name": "Cuba"
    },
    "DK": {
        "name": "Danemark"
    },
    "DJ": {
        "name": "Djibouti"
    },
    "DO": {
        "name": "République dominicaine"
    },
    "DM": {
        "name": "Dominique"
    },
    "EG": {
        "name": "Égypte"
    },
    "SV": {
        "name": "Salvador"
    },
    "AE": {
        "name": "Émirats arabes unis"
    },
    "EC": {
        "name": "Équateur (pays)"
    },
    "ER": {
        "name": "Érythrée"
    },
    "ES": {
        "name": "Espagne"
    },
    "EE": {
        "name": "Estonie"
    },
    "US": {
        "name": "États-Unis"
    },
    "ET": {
        "name": "Éthiopie"
    },
    "FJ": {
        "name": "Fidji"
    },
    "FI": {
        "name": "Finlande"
    },
    "FR": {
        "name": "France"
    },
    "GA": {
        "name": "Gabon"
    },
    "GM": {
        "name": "Gambie"
    },
    "GE": {
        "name": "Géorgie (pays)"
    },
    "GH": {
        "name": "Ghana"
    },
    "GR": {
        "name": "Grèce"
    },
    "GD": {
        "name": "Grenade (pays)"
    },
    "GT": {
        "name": "Guatemala"
    },
    "GN": {
        "name": "Guinée"
    },
    "GW": {
        "name": "Guinée-Bissau"
    },
    "GQ": {
        "name": "Guinée équatoriale"
    },
    "GY": {
        "name": "Guyana"
    },
    "HT": {
        "name": "Haïti"
    },
    "HN": {
        "name": "Honduras"
    },
    "HU": {
        "name": "Hongrie"
    },
    "IN": {
        "name": "Inde"
    },
    "ID": {
        "name": "Indonésie"
    },
    "IR": {
        "name": "Iran"
    },
    "IQ": {
        "name": "Irak"
    },
    "IE": {
        "name": "Irlande (pays)"
    },
    "IS": {
        "name": "Islande"
    },
    "IL": {
        "name": "Israël"
    },
    "IT": {
        "name": "Italie"
    },
    "JM": {
        "name": "Jamaïque"
    },
    "JP": {
        "name": "Japon"
    },
    "JO": {
        "name": "Jordanie"
    },
    "KZ": {
        "name": "Kazakhstan"
    },
    "KE": {
        "name": "Kenya"
    },
    "KG": {
        "name": "Kirghizistan"
    },
    "KI": {
        "name": "Kiribati"
    },
    "KW": {
        "name": "Koweït"
    },
    "LA": {
        "name": "Laos"
    },
    "LS": {
        "name": "Lesotho"
    },
    "LV": {
        "name": "Lettonie"
    },
    "LB": {
        "name": "Liban"
    },
    "LR": {
        "name": "Liberia"
    },
    "LY": {
        "name": "Libye"
    },
    "LI": {
        "name": "Liechtenstein"
    },
    "LT": {
        "name": "Lituanie"
    },
    "LU": {
        "name": "Luxembourg (pays)"
    },
    "MK": {
        "name": "Macédoine du Nord"
    },
    "MG": {
        "name": "Madagascar"
    },
    "MY": {
        "name": "Malaisie"
    },
    "MW": {
        "name": "Malawi"
    },
    "MV": {
        "name": "Maldives"
    },
    "ML": {
        "name": "Mali"
    },
    "MT": {
        "name": "Malte"
    },
    "MA": {
        "name": "Maroc"
    },
    "MH": {
        "name": "Îles Marshall (pays)"
    },
    "MU": {
        "name": "Maurice (pays)"
    },
    "MR": {
        "name": "Mauritanie"
    },
    "MX": {
        "name": "Mexique"
    },
    "FM": {
        "name": "États fédérés de Micronésie (pays)"
    },
    "MD": {
        "name": "Moldavie"
    },
    "MC": {
        "name": "Monaco"
    },
    "MN": {
        "name": "Mongolie"
    },
    "ME": {
        "name": "Monténégro"
    },
    "MZ": {
        "name": "Mozambique"
    },
    "MM": {
        "name": "Birmanie"
    },
    "NA": {
        "name": "Namibie"
    },
    "NR": {
        "name": "Nauru"
    },
    "NP": {
        "name": "Népal"
    },
    "NI": {
        "name": "Nicaragua"
    },
    "NE": {
        "name": "Niger"
    },
    "NG": {
        "name": "Nigeria"
    },
    "NO": {
        "name": "Norvège"
    },
    "NZ": {
        "name": "Nouvelle-Zélande"
    },
    "OM": {
        "name": "Oman"
    },
    "UG": {
        "name": "Ouganda"
    },
    "UZ": {
        "name": "Ouzbékistan"
    },
    "PK": {
        "name": "Pakistan"
    },
    "PW": {
        "name": "Palaos"
    },
    "PA": {
        "name": "Panama"
    },
    "PG": {
        "name": "Papouasie-Nouvelle-Guinée"
    },
    "PY": {
        "name": "Paraguay"
    },
    "NL": {
        "name": "Pays-Bas"
    },
    "PE": {
        "name": "Pérou"
    },
    "PH": {
        "name": "Philippines"
    },
    "PL": {
        "name": "Pologne"
    },
    "PT": {
        "name": "Portugal"
    },
    "QA": {
        "name": "Qatar"
    },
    "RO": {
        "name": "Roumanie"
    },
    "GB": {
        "name": "Royaume-Uni"
    },
    "RU": {
        "name": "Russie"
    },
    "RW": {
        "name": "Rwanda"
    },
    "KN": {
        "name": "Saint-Christophe-et-Niévès"
    },
    "SM": {
        "name": "Saint-Marin"
    },
    "VC": {
        "name": "Saint-Vincent-et-les-Grenadines"
    },
    "LC": {
        "name": "Sainte-Lucie"
    },
    "SB": {
        "name": "Îles Salomon"
    },
    "WS": {
        "name": "Samoa"
    },
    "ST": {
        "name": "Sao Tomé-et-Principe"
    },
    "SN": {
        "name": "Sénégal"
    },
    "RS": {
        "name": "Serbie"
    },
    "SC": {
        "name": "Seychelles"
    },
    "SL": {
        "name": "Sierra Leone"
    },
    "SG": {
        "name": "Singapour"
    },
    "SK": {
        "name": "Slovaquie"
    },
    "SI": {
        "name": "Slovénie"
    },
    "SO": {
        "name": "Somalie"
    },
    "SD": {
        "name": "Soudan"
    },
    "SS": {
        "name": "Soudan du Sud"
    },
    "LK": {
        "name": "Sri Lanka"
    },
    "SE": {
        "name": "Suède"
    },
    "CH": {
        "name": "Suisse"
    },
    "SR": {
        "name": "Suriname"
    },
    "SZ": {
        "name": "Eswatini"
    },
    "SY": {
        "name": "Syrie"
    },
    "TJ": {
        "name": "Tadjikistan"
    },
    "TZ": {
        "name": "Tanzanie"
    },
    "TD": {
        "name": "Tchad"
    },
    "CZ": {
        "name": "Tchéquie"
    },
    "TH": {
        "name": "Thaïlande"
    },
    "TL": {
        "name": "Timor oriental"
    },
    "TG": {
        "name": "Togo"
    },
    "TO": {
        "name": "Tonga"
    },
    "TT": {
        "name": "Trinité-et-Tobago"
    },
    "TN": {
        "name": "Tunisie"
    },
    "TM": {
        "name": "Turkménistan"
    },
    "TR": {
        "name": "Turquie"
    },
    "TV": {
        "name": "Tuvalu"
    },
    "UA": {
        "name": "Ukraine"
    },
    "UY": {
        "name": "Uruguay"
    },
    "VU": {
        "name": "Vanuatu"
    },
    "VE": {
        "name": "Venezuela"
    },
    "VN": {
        "name": "Viêt Nam"
    },
    "YE": {
        "name": "Yémen"
    },
    "ZM": {
        "name": "Zambie"
    },
    "ZW": {
        "name": "Zimbabwe"
    }
}